import concat from 'lodash/concat';

export const utmTrackingDefaultSourceShortListVals = [
  'Website',
  'Email Marketing',
  'Facebook',
  'Instagram',
  'Google',
  'Other',
];

export const utmTrackingDefaultSourceVals = concat(
  utmTrackingDefaultSourceShortListVals,
  [
    'Past Client',
    'Phone',
    'Email',
    'Walk-in',
    'Word of Mouth',
    'Referral',
    'OpenTable',
    'Tock',
    'WeddingWire',
    'The Knot',
    'Eventective',
    'QR Code',
    'Yelp',
    'PV Marketplace',
  ]
);
